import { Worker } from "@react-pdf-viewer/core";
import { PropsWithChildren } from "react";
import { PDFJS_WORKER_URL } from "utils/pdfjsWorker";

const WithPdfJsWorker: React.FC<PropsWithChildren> = ({ children }) => {
  return <Worker workerUrl={PDFJS_WORKER_URL}>{children}</Worker>;
};

export default WithPdfJsWorker;
